import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d8169bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header_left" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "产品", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-text" }, " 应用案例 ", -1 /* HOISTED */))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "服务", -1 /* HOISTED */))
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "header-right" }
const _hoisted_11 = { class: "mobile-menu" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "产品", -1 /* HOISTED */))
const _hoisted_14 = { class: "sub-title" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "服务", -1 /* HOISTED */))
const _hoisted_18 = { class: "sub-title" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = { class: "title" }

import { ref, watch, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { UseIcon } from '@/components';
import { AUTH_STORE, LAYOUT_STORE } from '@/store';
import { getStore } from '@uds/pinia-manager';
import { logout } from '@/service/api/auth/index';
import { getRefreshToken, removeRefreshToken, removeToken, getToken } from '@/utils/storage';
import QyLogo from '../../../public/images/logo.png';
import QyLogoDark from '../../../public/images/logo_dark.png';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    isDark: {
        type: Boolean,
        default: true,
    },
},
  setup(__props) {

const props = __props;



const authStore = getStore(AUTH_STORE);
const layoutStore = getStore(LAYOUT_STORE);
const { helpDocUrl, installPdfUrl } = window.ENV_CONFIG;

const style = ref({
    background: 'transparent',
    boxShadow: '0px 0px 0px 0px rgba(0,0,0,0)',
});

let headerWidth = 0;

watch(
    () => props.isDark,
    (val) => {
        if (val) {
            if (headerWidth >= 800) {
                style.value = {
                    background: 'transparent', // #FEFFFF
                    boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.06)',
                };
            } else {
                style.value = {
                    background: '#FEFFFF', // #FEFFFF
                    boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.06)',
                };
            }
        } else {
            style.value = {
                background: 'transparent',
                boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.06)',
            };
        }
        // if (val) {
        //     style.value = {
        //         background: "#FEFFFF", // #FEFFFF
        //         boxShadow: "0px 1px 5px 0px rgba(0,0,0,0.06)"
        //     };
        // } else {
        //     style.value = {
        //         background: "transparent",
        //         boxShadow: "0px 1px 5px 0px rgba(0,0,0,0.06)"
        //     };
        // }
    },
    {
        immediate: true,
    },
);

const router = useRouter();
const route = useRoute();

const showDropdownBar = ref(false);
const dropdownContent = ref('');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let dropdownTimer: any;

const triggerEnter = (content: string | null) => {
    clearTimeout(dropdownTimer);
    if (content) {
        dropdownContent.value = content;
    }
    showDropdownBar.value = true;
};
const triggerLeave = () => {
    dropdownTimer = setTimeout(() => {
        showDropdownBar.value = false;
    }, 300);
};
const scrollTo = async (index: number) => {
    if (route.path !== '/home') {
        await router.push('/home');
    }
    layoutStore.homeScrollTo(index);
};

const jumpTo = (toPath: string, site = false) => {
    if (route.path === toPath) return;
    if (site) {
        window.open(toPath, '_blank');
        return;
    }
    router.push(toPath).catch((error) => console.log(error));
};

const goLogout = () => {
    if (!getToken()) return;
    logout()
        .catch((error) => console.error(error))
        .finally(() => {
            authStore.clearUserInfo();
            removeRefreshToken();
            removeToken();
            router.push('/login').catch((error) => console.error(error));
        });
};

const handleCommandClick = (path: string) => {
    if (path === '/login') {
        goLogout();
    } else {
        jumpTo(path);
    }
};

const goUse = () => {
    if (route.query.redirect) {
        const redirect = decodeURIComponent(route.query.redirect as string);
        if (getToken() && getRefreshToken() && authStore.userInfo.id) {
            // 跳转重定向地址
            if (redirect.includes('http://') || redirect.includes('https://')) {
                // 判断原地址是否携带参数
                if (redirect.indexOf('?') !== -1) {
                    window.open(`${redirect}&refreshToken=${getRefreshToken()}`, '_blank');
                } else {
                    window.open(`${redirect}?refreshToken=${getRefreshToken()}`, '_blank');
                }
            } else {
                router.push({ path: redirect as string }).catch((error) => console.log(error));
            }
        } else {
            authStore.clearUserInfo();
            removeRefreshToken();
            removeToken();
            router
                .push({
                    path: '/login',
                    query: {
                        redirect: encodeURIComponent(redirect as string),
                    },
                })
                .catch((error) => console.log(error));
        }
    } else if (getToken() && getRefreshToken() && authStore.userInfo.id) {
        window.open(`${window.ENV_CONFIG.viewerURL}?refreshToken=${getRefreshToken()}`, '_blank');
        router.push('/home').catch((error) => console.log(error));
    } else {
        authStore.clearUserInfo();
        removeRefreshToken();
        removeToken();
        // 跳转登录再跳转 viewer ———— 指定viewer地址
        router
            .push({
                path: '/login',
                query: {
                    redirect: encodeURIComponent(window.ENV_CONFIG.viewerURL),
                },
            })
            .catch((error) => console.log(error));
    }
};

const goPartSearch = () => {
    const redirect = decodeURIComponent(route.query.redirect as string);
    if (!getRefreshToken()) {
        authStore.clearUserInfo();
        removeRefreshToken();
        removeToken();
        router.push({ path: '/login' }).catch((error) => console.log(error));
    }
    if (route.query.redirect) {
        window.open(`${redirect}?refreshToken=${getRefreshToken()}`, '_blank');
        const { href } = document.location;
        const target = href
            .replace(/&?redirect=(([\w\\.\\-])*)/, '')
            .replace(/(\?|&)$/, '')
            .replace('?&', '?');
        window.location.replace(target);
    } else {
        window.open(`${window.ENV_CONFIG.partSearchURL}mms-web/#/upload?refreshToken=${getRefreshToken()}`, '_blank');
    }
};

// —————————————————————————————————————— collapse ——————————————————————————————————————
const mobileActive = ref<number>(0);
const expand = ref<boolean>(false);
// const handleChange = () => {
//     console.log(123);
// };
const expandOrActive = (key: number) => {
    if (mobileActive.value === key) {
        mobileActive.value = 0;
        return;
    }
    mobileActive.value = key;
};

const mobileScrollTo = async (key: number) => {
    await scrollTo(key);
    expand.value = false;
};

onMounted(() => {
    headerWidth = document.body.clientWidth;
});
// —————————————————————————————————————— collapse ——————————————————————————————————————

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "header",
      style: _normalizeStyle(style.value)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: __props.isDark ? _unref(QyLogoDark) : _unref(QyLogo),
          class: "header-logo",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollTo(0)))
        }, null, 8 /* PROPS */, _hoisted_2)
      ]),
      _createElementVNode("div", {
        class: "header-center",
        style: _normalizeStyle({ color: __props.isDark ? '#131415' : '#feffff' })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "title-text",
            onMouseover: _cache[1] || (_cache[1] = ($event: any) => (triggerEnter('production'))),
            onMouseleave: triggerLeave
          }, [
            _hoisted_4,
            _createVNode(_unref(UseIcon), {
              iconClass: "icon-arrow_down",
              fontSize: 20,
              class: "arrow"
            })
          ], 32 /* HYDRATE_EVENTS */)
        ]),
        _createElementVNode("div", {
          class: "title",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (scrollTo(5)))
        }, _hoisted_6),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "title-text",
            onMouseover: _cache[3] || (_cache[3] = ($event: any) => (triggerEnter('service'))),
            onMouseleave: triggerLeave
          }, [
            _hoisted_8,
            _createVNode(_unref(UseIcon), {
              iconClass: "icon-arrow_down",
              fontSize: 20,
              class: "arrow"
            })
          ], 32 /* HYDRATE_EVENTS */)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: "title-text",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (jumpTo('/aboutUs')))
          }, " 关于我们 ")
        ])
      ], 4 /* STYLE */),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_dropdown, {
          "show-timeout": 100,
          "hide-timeout": 100,
          onCommand: handleCommandClick
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, { command: "/userCenter" }, {
                  default: _withCtx(() => [
                    _createTextVNode("用户中心 ")
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_dropdown_item, { command: "/login" }, {
                  default: _withCtx(() => [
                    _createTextVNode("退出登录 ")
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(UseIcon), {
              iconClass: "icon-user_login",
              fontSize: 22,
              color: __props.isDark ? '#57616E' : '#feffff',
              class: "svg-icon"
            }, null, 8 /* PROPS */, ["color"])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _createCommentVNode(" Mobile "),
      _createElementVNode("div", {
        class: "header-right-mobile",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (expand.value = !expand.value))
      }, [
        _createVNode(_unref(UseIcon), {
          iconClass: "icon-zhankai",
          fontSize: 16,
          color: __props.isDark ? '#57616E' : '#feffff',
          class: "svg-icon"
        }, null, 8 /* PROPS */, ["color"])
      ])
    ], 4 /* STYLE */),
    _createVNode(_Transition, {
      name: "plane-anime",
      persisted: ""
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          ref: "productionPlane",
          class: "sub-nav-plane production-plane",
          onMouseover: _cache[9] || (_cache[9] = ($event: any) => (triggerEnter(null))),
          onMouseleave: triggerLeave
        }, [
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", {
              class: "prod",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (scrollTo(0)))
            }, "青翼CAM"),
            _createVNode(_component_el_divider, {
              class: "divider",
              direction: "vertical"
            }),
            _createElementVNode("div", {
              class: "prod",
              onClick: goUse
            }, "青翼三维工艺可视化"),
            _createVNode(_component_el_divider, {
              class: "divider",
              direction: "vertical"
            }),
            _createElementVNode("div", {
              class: "prod",
              onClick: goPartSearch
            }, "零件搜索")
          ], 512 /* NEED_PATCH */), [
            [_vShow, dropdownContent.value === 'production']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", {
              class: "prod",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (jumpTo(_unref(helpDocUrl), true)))
            }, " 青翼CAM帮助手册 "),
            _createVNode(_component_el_divider, {
              class: "divider",
              direction: "vertical"
            }),
            _createElementVNode("div", {
              class: "prod",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (jumpTo(_unref(installPdfUrl), true)))
            }, " 青翼CAM安装说明 ")
          ], 512 /* NEED_PATCH */), [
            [_vShow, dropdownContent.value === 'service']
          ])
        ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vShow, showDropdownBar.value]
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" Mobile "),
    _createVNode(_Transition, {
      name: "mobile-menu-anime",
      persisted: ""
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: _normalizeClass(["main-text", { active: mobileActive.value === 1 }]),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (expandOrActive(1)))
            }, [
              _hoisted_13,
              _createVNode(_unref(UseIcon), {
                iconClass: mobileActive.value === 1 ? 'icon-arrow_up' : 'icon-arrow_down',
                fontSize: 21,
                color: mobileActive.value === 1 ? '#237fe8' : '#57616e',
                class: "menu-icon"
              }, null, 8 /* PROPS */, ["iconClass", "color"])
            ], 2 /* CLASS */),
            _withDirectives(_createElementVNode("div", _hoisted_14, [
              _createElementVNode("li", {
                onClick: _cache[11] || (_cache[11] = ($event: any) => (mobileScrollTo(0)))
              }, "青翼CAM"),
              _createElementVNode("li", { onClick: goUse }, "青翼三维工艺可视化"),
              _createElementVNode("li", { onClick: goPartSearch }, "零件搜索")
            ], 512 /* NEED_PATCH */), [
              [_vShow, mobileActive.value === 1]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: "main-text",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (mobileScrollTo(5)))
            }, "应用案例")
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", {
              class: _normalizeClass(["main-text", { active: mobileActive.value === 3 }]),
              onClick: _cache[13] || (_cache[13] = ($event: any) => (expandOrActive(3)))
            }, [
              _hoisted_17,
              _createVNode(_unref(UseIcon), {
                iconClass: mobileActive.value === 3 ? 'icon-arrow_up' : 'icon-arrow_down',
                fontSize: 21,
                color: mobileActive.value === 3 ? '#237fe8' : '#57616e',
                class: "menu-icon"
              }, null, 8 /* PROPS */, ["iconClass", "color"])
            ], 2 /* CLASS */),
            _withDirectives(_createElementVNode("div", _hoisted_18, [
              _createElementVNode("li", {
                onClick: _cache[14] || (_cache[14] = ($event: any) => (jumpTo(_unref(helpDocUrl), true)))
              }, "青翼CAM帮助手册"),
              _createElementVNode("li", {
                onClick: _cache[15] || (_cache[15] = ($event: any) => (jumpTo(_unref(installPdfUrl), true)))
              }, " 青翼CAM安装说明 ")
            ], 512 /* NEED_PATCH */), [
              [_vShow, mobileActive.value === 3]
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", {
              class: "main-text",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (jumpTo('/aboutUs')))
            }, " 关于我们 ")
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", {
              class: "main-text",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (handleCommandClick('/userCenter')))
            }, " 用户中心 ")
          ]),
          _createElementVNode("div", {
            class: "log-out",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (handleCommandClick('/login')))
          }, " 退出登录 ")
        ], 512 /* NEED_PATCH */), [
          [_vShow, expand.value]
        ])
      ]),
      _: 1 /* STABLE */
    })
  ], 64 /* STABLE_FRAGMENT */))
}
}

})